export default {"src":"/_next/static/media/coinWithChart_64.e083f619.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};